import { ResponsiveComponentProps, ResponsiveWrapper } from '../ResponsiveWrapper';
import { BarChartBase, BarChartBaseProps } from './BarChartBase';

export type ResponsiveBarChartBaseProps = ResponsiveComponentProps<BarChartBaseProps>;

export function ResponsiveBarChartBase({
  width: overrideWidth,
  height: overrideHeight,
  ...componentProps
}: ResponsiveBarChartBaseProps) {
  return (
    <ResponsiveWrapper width={overrideWidth} height={overrideHeight}>
      {({ width, height }) => {
        return <BarChartBase width={width} height={height} {...componentProps} />;
      }}
    </ResponsiveWrapper>
  );
}
